<div class="d-flex flex-column justify-content-center wrapper">
  <div class="offcanvas-body d-flex flex-column">
    <h4 class="mt-2">{{ 'Credits Summary' | translate }}</h4>

    <div class="mt-4 d-flex justify-content-between align-items-center">
      <h6>{{ 'Sales Transactions' | translate }}</h6>
      <div>{{ accountSummary?.salePoints | number }}</div>
    </div>
    <div class="mt-2 d-flex justify-content-between align-items-center" *ngIf="!isJapan">
      <h6>{{ 'Training and Certifications' | translate }}</h6>
      <div>{{ accountSummary?.learnPoints | number }}</div>
    </div>
    <div class="mt-2 d-flex justify-content-between align-items-center" *ngIf="!isJapan">
      <h6>{{ 'Promotions' | translate }}</h6>
      <div>{{ accountSummary?.promoPoints | number }}</div>
    </div>
    <div class="mt-2 d-flex justify-content-between align-items-center">
      <h6>{{ 'Redeemed' | translate }}</h6>
      <div>{{ accountSummary?.redeemedPoints | number }}</div>
    </div>
    <div class="mt-2 d-flex justify-content-between align-items-center">
      <h6>{{ 'Expired' | translate }}</h6>
      <div>{{ accountSummary?.expiredPoints | number }}</div>
    </div>
    <div class="mt-2 d-flex justify-content-between align-items-center">
      <h6>{{ 'Total' | translate }}</h6>
      <div>{{ accountSummary?.availableBalance | number }}</div>
    </div>
  </div>
  <ng-container
    *ngIf="
      pastYearAccountSummary && pastYearAccountSummary.expirationDate !== currentYearAccountSummary?.expirationDate
    "
  >
    <ng-container
      *ngIf="
        pastYearAccountSummary.availableBalance &&
        pastYearAccountSummary.availableBalance > 0 &&
        pastYearAccountSummary.expirationDate !== currentYearAccountSummary?.expirationDate
      "
    >
      <hr />
      <div class="offcanvas-body d-flex flex-column">
        <div class="d-flex justify-content-between align-items-center">
          <h6>
            {{
              'Credits available to redeem until'
                | translate : { untilDate: pastYearAccountSummary.expirationDate | localisedDate : 'mediumDate' }
            }}
          </h6>
          <div class="ms-3">{{ pastYearAccountSummary.availableBalance | number }}</div>
        </div>
      </div>
    </ng-container>
  </ng-container>
  <ng-container
    *ngIf="
      currentYearAccountSummary && pastYearAccountSummary?.expirationDate !== currentYearAccountSummary.expirationDate
    "
  >
    <hr />
    <div class="offcanvas-body d-flex flex-column">
      <div class="d-flex justify-content-between align-items-center">
        <h6>
          {{
            'Credits available to redeem until'
              | translate : { untilDate: currentYearAccountSummary.expirationDate | localisedDate : 'mediumDate' }
          }}
        </h6>
        <div class="ms-3">{{ currentYearAccountSummary.availableBalance | number }}</div>
      </div>
    </div>
  </ng-container>
  <ng-container
    *ngIf="pastYearAccountSummary?.expirationDate === currentYearAccountSummary?.expirationDate && accountSummary"
  >
    <hr />
    <div class="offcanvas-body d-flex flex-column">
      <div class="d-flex justify-content-between align-items-center">
        <h6>
          {{
            'Credits available to redeem until'
              | translate : { untilDate: accountSummary.expirationDate | localisedDate : 'mediumDate' }
          }}
        </h6>
        <div class="ms-3">{{ accountSummary.availableBalance | number }}</div>
      </div>
    </div>
  </ng-container>

  <div class="offcanvas-body d-flex flex-column business-rule" *ngFor="let rule of businessRules">
    <div class="mt-2 py-2 d-flex justify-content-start align-items-start" *ngIf="rule.displayKey">
      <div class="warning-icon me-2">
        <fa-icon [icon]="['far', 'exclamation-triangle']"></fa-icon>
      </div>
      <div class="me-4 message-content" [innerHTML]="rule.displayKey | translate : rule.parameters | safeHtml"></div>
    </div>
  </div>
</div>
